import type { Connection } from '@bentley/pw-wac';
import { readUniversalLinkParams } from '../searchParams/searchParams';

export function parseDefaultTabHref(connection: Connection): string {
  if (!connection.DefaultTab) {
    return '';
  }

  const teamsUrl = new URL(connection.DefaultTab);
  setContextOnUrl(teamsUrl);

  return teamsUrl.href;
}

function setContextOnUrl(teamsUrl: URL): void {
  const context = parseContextInfo(teamsUrl);
  context.subEntityId = buildSubEntityId();

  teamsUrl.searchParams.set('context', JSON.stringify(context));
}

function parseContextInfo(teamsUrl: URL): Record<string, string> {
  const context = teamsUrl.searchParams.get('context');
  if (!context) {
    return {};
  }

  const contextInfo = JSON.parse(context) as Record<string, string>;
  return contextInfo;
}

function buildSubEntityId(): string {
  const { objectId, objectType, savedSearchId, workAreaId } =
    readUniversalLinkParams();
  const subEntityInfo = [
    '',
    workAreaId,
    objectId,
    objectType,
    savedSearchId
  ].join('--');
  // setId, projectId, itemId, itemType, savedSearchId

  const subEntityId = encodeURIComponent(subEntityInfo);
  return subEntityId;
}
